import styled from 'styled-components';
import { media } from 'utils/rwd';

const NavigationWrapper = styled.nav.attrs({
  className: 'navbar navbar-vertical navbar-expand-md fixed-left navbar-dark',
})`
  background: rgba(0, 0, 0, 0.9);
  overflow: visible !important;
  height: 100vh;
  flex: 1;
  max-width: ${({ $compact }) => ($compact ? '66px !important' : 'auto')};

  .container-fluid {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .navbar-collapse {
    flex: 1;
    min-height: 0;
  }

  .navbar-nav {
    min-height: 0;
  }

  .nav-link {
    padding-top: 0.45rem;
    padding-bottom: 0.45rem;
  }

  ${media.sm.down`
    max-width: 100% !important;
    flex: 0 1 auto;
    height: auto;
  `}

  .dropdown-menu {
    .nav-link.active span {
      color: ${({ $compact }) => ($compact ? '#000000' : '#ffffff')};
      &:hover {
        color: ${({ $compact }) => ($compact ? '#000000' : '#ffffff')};
      }
    }
  }

  .dropdown-menu {
    .nav-link {
      &:hover {
        color: ${({ $compact }) => ($compact ? '#000000' : '#ffffff')};
      }
    }
  }
`;

const NavigationLinkLabel = styled.span`
  font-size: 13px;
  display: ${({ $compact, $subItem }) => {
    const subItemClass = $subItem ? 'inline-block' : 'none';
    return $compact ? subItemClass : 'inline-block';
  }};
  @media (max-width: 767px) {
    display: inline-block;
  }
  ${({ $active }) => $active && 'color: white !important;'}
`;

const ToggleMenuButton = styled.button.attrs({
  type: 'button',
  className: 'btn btn-white rounded-circle d-none d-md-block',
})`
  position: absolute;
  bottom: 75px;
  right: -20px;
  padding: 8px 12px;
  z-index: 10;
`;

const BurgerMenuButton = styled.button.attrs({
  className: 'navbar-toggler',
  type: 'button',
})`
  align-self: flex-start;
`;

const NavigationLogo = styled.img`
  padding: 8px 0 16px 0;
  margin: 0 auto;
  height: auto;
  max-height: 80px;
  max-width: 80%;
  display: ${({ $compact }) => ($compact ? 'none' : 'block')};

  ${media.sm.down`
    display: block;
    position: absolute;
    left: calc(50% - 80px);
    top: 12px;
    opacity: 1;
    padding: 0;
    height: 40px;
`}
`;
export {
  BurgerMenuButton,
  NavigationLinkLabel,
  NavigationLogo,
  NavigationWrapper,
  ToggleMenuButton,
};
